import React, {Component} from 'react';

import './Window.css';

export default class DesktopWindow extends Component {
    render() {
        const {title, children} = this.props;
        return <div ref="window" className="DesktopWindow">
            <div className="DesktopWindow-header">
                <svg
                    className="DesktopWindow-header-buttons"
                    viewBox="0 0 80 24"
                    xmlns="http://www.w3.org/2000/svg"
                    width="80"
                    height="24">
                    <circle cx="16" cy="12" r="6" fill="#ff5c5c" stroke="#e33e41" strokeWidth="1"/>
                    <circle cx="40" cy="12" r="6" fill="#ffbd4c" stroke="#e09e3e" strokeWidth="1"/>
                    <circle cx="64" cy="12" r="6" fill="#00ca56" stroke="#14ae46" strokeWidth="1"/>
                </svg>
                <h1 className="DesktopWindow-header-title">{title}</h1>
            </div>
            <div className="DesktopWindow-body">{children}</div>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/desktop/Window.js